import { KitchenStoveContainer } from '../../containers/advancedFilters/KitchenStoveContainer';
import { IFilter } from '../../types/advancedFilters';

export const kitchenStove: IFilter = {
  component: KitchenStoveContainer,
};
